import { OptionQuestion } from '@hb/domain';
import { OptionPipe } from '@hb/modules/financial-obligations/transformer/option/option-pipe';
import { StudentDebtComponent } from '@hb/modules/financial-obligations/student-debt/student-debt.component';
import { PaymentAccountOverdraftComponent } from '@hb/modules/financial-obligations/payment-account-overdraft/payment-account-overdraft.component';
import { MobilePhonePaymentComponent } from '@hb/modules/financial-obligations/mobile-phone-payment/mobile-phone-payment.component';
import { OpenEndedCreditComponent } from '@hb/modules/financial-obligations/open-ended-credit/open-ended-credit.component';
import { CreditCardComponent } from '@hb/modules/financial-obligations/credit-card/credit-card.component';
import { PrivateLeaseComponent } from '@hb/modules/financial-obligations/private-lease/private-lease.component';
import { PersonalLoanComponent } from '@hb/modules/financial-obligations/personal-loan/personal-loan.component';
import { PartnerAlimonyComponent } from '@hb/modules/financial-obligations/partner-alimony/partner-alimony.component';

import { ReactiveFormsModule } from '@angular/forms';
import { Component } from '@angular/core';

import { ApContentPipe } from '@ap/content';
import { ApCheckboxComponent } from '@ap/checkbox';
import { ApNotificationComponent } from '@ap/notification';

import { AbstractOption } from '../abstract-options.component';

@Component({
    selector: 'financial-obligations-summary',
    imports: [
        ReactiveFormsModule,
        ApCheckboxComponent,
        OptionPipe,
        ApContentPipe,
        StudentDebtComponent,
        PaymentAccountOverdraftComponent,
        MobilePhonePaymentComponent,
        OpenEndedCreditComponent,
        CreditCardComponent,
        PrivateLeaseComponent,
        PersonalLoanComponent,
        PartnerAlimonyComponent,
        ApNotificationComponent
    ],
    templateUrl: './financial-obligations-summary.component.html'
})
export class FinancialObligationsSummaryComponent extends AbstractOption {
    optionQuestion = OptionQuestion;
}
